<template>
  <form
    ref="form"
    data-url="/organizations"
    class="mb-0"
    :class="{ 'loading-opacity': preloader }"
  >
    <div class="row">
      <div class="col-md-6">
        <div class="form-group">
          <label>Seleccione la Organización</label>
          <app-input
            type="select"
            v-model="selected"
            :list="orgList"
            :disabled="disabled"
          />
        </div>
      </div>
    </div>

    <div class="row">
      <legend class="col-12 col-form-label text-primary pt-0 my-3">
        <h5>1. DATOS GENERALES DEL ORGANISMO SOLICITANTE</h5>
      </legend>

      <div
        class="col-md-6"
        v-if="
          [
            'OEYC',
            'OENY',
            'OCLN',
            'OICC',
            'OEAP',
            'OINSP',
            'OCSG',
            'CSIA',
            'CSA',
            'CSGAS',
            'OCPR',
          ].includes(activity)
        "
      >
        <div class="form-group">
          <label>Nombre Comercial</label>
          <app-input
            type="text"
            v-model="inputs.org.name"
            :disabled="disabled"
            placeholder="Ingrese el Nombre Comercial"
            :required="true"
          />
        </div>
      </div>

      <div class="col-md-6">
        <div class="form-group">
          <label>Tipo de Identificación</label>
          <app-input
            type="select"
            v-model="inputs.org.taxid_type"
            v-on:change="onChangeTaxid"
            :required="true"
            :list="taxidTypeLists"
            :disabled="disabled"
          />
        </div>
      </div>

      <div class="col-md-6">
        <div class="form-group">
          <label>RUC</label>
          <app-input
            type="text"
            v-model="inputs.org.taxid"
            :disabled="disabled"
            placeholder="Ingrese el RUC"
            :required="true"
            @keyup="onChangeTaxid"
          />
        </div>
      </div>

      <div class="col-md-6">
        <div class="form-group">
          <label>Razón Social</label>
          <app-input
            type="text"
            v-model="inputs.org.business_name"
            :disabled="disabled"
            :required="true"
            placeholder="Ingrese la Razón Social"
          />
        </div>
      </div>

      <div class="col-md-6">
        <div class="form-group">
          <label>Integración del Capital Social (% Nacional)</label>
          <app-input
            type="select"
            v-model="inputs.org.national_capital"
            :list="percentage"
            :disabled="disabled"
          />
        </div>
      </div>

      <div class="col-md-6">
        <div class="form-group">
          <label>Integración del Capital Social (% Extranjero)</label>
          <app-input
            type="number"
            v-model="inputs.org.foreign_capital"
            :disabled="true"
            placeholder="Ingrese la Integración del Capital Social (% Extranjero)"
          />
        </div>
      </div>

      <div
        class="col-md-6"
        v-if="
          [
            'OEYC',
            'OENY',
            'OCLN',
            'OICC',
            'OEAP',
            'OCSG',
            'CSIA',
            'CSA',
            'CSGAS',
            'OCPR',
          ].includes(activity)
        "
      >
        <div class="form-group">
          <label>Representante Legal</label>
          <app-input
            type="text"
            v-model="inputs.org.legal_representative"
            :disabled="disabled"
            :required="true"
            placeholder="Ingrese el Representante Legal"
          />
        </div>
      </div>

      <div
        class="col-md-6"
        v-if="
          [
            'OEYC',
            'OENY',
            'OCLN',
            'OICC',
            'OEAP',
            'OCSG',
            'CSIA',
            'CSA',
            'CSGAS',
            'OCPR',
          ].includes(activity)
        "
      >
        <div class="form-group">
          <label>Tipo de Identificación</label>
          <app-input
            type="select"
            v-model="inputs.org.lr_taxid_type"
            v-on:change="onChangeLrTaxid"
            :required="true"
            :list="lrTaxidTypeLists"
            :disabled="disabled"
          />
        </div>
      </div>

      <div
        class="col-md-6"
        v-if="
          [
            'OEYC',
            'OENY',
            'OCLN',
            'OICC',
            'OEAP',
            'OCSG',
            'CSIA',
            'CSA',
            'CSGAS',
            'OCPR',
          ].includes(activity)
        "
      >
        <div class="form-group">
          <label>C.I.</label>
          <app-input
            type="text"
            v-model="inputs.org.legal_representative_taxid"
            :disabled="disabled"
            placeholder="Ingrese la C.I."
            :required="true"
            @keyup="onChangeLrTaxid"
          />
        </div>
      </div>

      <div
        class="col-md-6"
        v-if="
          [
            'OEYC',
            'OENY',
            'OCLN',
            'OEAP',
            'OINSP',
            'OCSG',
            'CSIA',
            'CSA',
            'CSGAS',
            'OCPR',
            'OCPE',
            'OICC',
          ].includes(activity)
        "
      >
        <div class="form-group">
          <label>Tipo de Entidad</label>
          <app-input
            type="select"
            v-model="inputs.org.organization_type"
            :required="true"
            :list="[
              { id: '', value: this.$t('select_option') },
              ...organizationTypeList,
            ]"
            :disabled="disabled"
          />
        </div>
      </div>

      <div class="col-md-6">
        <div class="form-group">
          <label>País</label>
          <app-input
            type="select"
            v-model="inputs.org.country_id"
            :list="[
              { id: '', value: this.$t('select_option') },
              ...this.$store.state.common.countries,
            ]"
            :required="true"
            :disabled="disabled"
          />
        </div>
      </div>

      <div
        class="col-md-6"
        v-if="inputs.org.country_id && provinceList.length <= 1"
      >
        <div class="form-group">
          <label>Ciudad</label>
          <app-input
            type="text"
            v-model="inputs.org.city"
            placeholder="Ingrese la Ciudad"
            :required="true"
            :disabled="disabled"
          />
        </div>
      </div>

      <div class="col-md-6" v-if="provinceList.length > 1">
        <div class="form-group">
          <label>Provincia</label>
          <app-input
            type="select"
            v-model="inputs.org.province_id"
            :list="[
              { id: '', value: this.$t('select_option') },
              ...provinceList,
            ]"
            :required="true"
            :disabled="disabled"
          />
        </div>
      </div>

      <div class="col-md-6" v-if="provinceList.length > 1">
        <div class="form-group">
          <label>Ciudad</label>
          <app-input
            type="select"
            v-model="inputs.org.canton_id"
            :list="[{ id: '', value: this.$t('select_option') }, ...cantonList]"
            :required="true"
            :disabled="disabled"
          />
        </div>
      </div>

      <div class="col-md-6">
        <div class="form-group">
          <label>E-mail</label>
          <app-input
            type="email"
            v-model="inputs.org.email"
            placeholder="Ingrese su E-mail"
            :required="true"
            :disabled="disabled"
          />
        </div>
      </div>

      <div class="col-md-6">
        <div class="form-group">
          <label>Teléfono</label>
          <app-input
            type="tel-input"
            v-model="inputs.org.phone"
            :disabled="disabled"
            :required="true"
            placeholder="Ingrese el Teléfono"
          />
        </div>
      </div>

      <div class="col-md-6">
        <div class="form-group">
          <label>Dirección</label>
          <app-input
            type="textarea"
            v-model="inputs.org.address"
            :required="true"
            :disabled="disabled"
            placeholder="Ingrese la Dirección"
          />
        </div>
      </div>

      <div class="col-md-6" v-if="['OCLN', 'OICC', 'OEAP'].includes(activity)">
        <div class="form-group">
          <label>Casilla</label>
          <app-input
            type="text"
            v-model="inputs.org.box"
            :required="true"
            :disabled="disabled"
            placeholder="Ingrese la Casilla"
          />
          <a href="https://www.codigopostal.gob.ec/" target="_blank"
            >Consultar Código Postal Ecuador</a
          >
        </div>
      </div>

      <div class="col-md-6" v-if="['OEYC', 'OENY'].includes(activity)">
        <div class="form-group">
          <label>Código Postal</label>
          <app-input
            type="text"
            v-model="inputs.org.postal_code"
            :required="true"
            :disabled="disabled"
            placeholder="Ingrese el Código Postal"
          />
          <a href="https://www.codigopostal.gob.ec/" target="_blank"
            >Consultar Código Postal Ecuador</a
          >
        </div>
      </div>

      <div
        class="col-md-6"
        v-if="
          ['OEYC', 'OENY', 'OCLN', 'OICC', 'OEAP', 'OINSP'].includes(activity)
        "
      >
        <div class="form-group">
          <label>Propietario(s)</label
          ><span class="text-warning ml-2">Si no aplica colocar N/A</span>
          <app-input
            type="textarea"
            v-model="inputs.org.owner"
            :required="true"
            :disabled="disabled"
            placeholder="Ingrese el(los) Propietario(s)"
          />
        </div>
      </div>

      <div class="col-md-6" v-if="['OICC', 'OEAP'].includes(activity)">
        <div class="form-group">
          <label>Dirección del Propietario</label
          ><span class="text-warning ml-2">Si no aplica colocar N/A</span>
          <app-input
            type="textarea"
            v-model="inputs.org.owner_address"
            :required="true"
            :disabled="disabled"
            placeholder="Ingrese la Dirección del Propietario"
          />
        </div>
      </div>

      <div class="col-md-6">
        <div class="form-group">
          <label>Pág. Web</label>
          <app-input
            type="text"
            v-model="inputs.org.web"
            :required="true"
            :disabled="disabled"
            placeholder="Ingrese la Página Web"
          />
        </div>
      </div>

      <div
        class="col-md-6"
        v-if="
          [
            'OEYC',
            'OENY',
            'OCLN',
            'OICC',
            'OINSP',
            'OCSG',
            'CSIA',
            'CSA',
            'CSGAS',
            'OCPR',
            'OCPE',
          ].includes(activity)
        "
      >
        <div class="form-group">
          <label>N° Total de Empleados</label>
          <app-input
            type="number"
            v-model="inputs.org.total_employees"
            :disabled="disabled"
            placeholder="Ingrese el nº Total de Empleados"
          />
        </div>
      </div>

      <div
        class="col-md-6"
        v-if="
          [
            'OEYC',
            'OENY',
            'OCLN',
            'OICC',
            'OINSP',
            'OCSG',
            'CSIA',
            'CSA',
            'CSGAS',
            'OCPR',
          ].includes(activity)
        "
      >
        <div class="form-group">
          <label>{{
            ["OEYC", "OENY", "OCLN", "OICC", "OINSP"].includes(activity)
              ? "Administrativos"
              : "N° de Auditores Fijos"
          }}</label>
          <app-input
            type="number"
            v-model="inputs.org.fixed_auditors"
            :disabled="disabled"
            :placeholder="
              ['OEYC', 'OENY', 'OCLN', 'OICC', 'OINSP'].includes(activity)
                ? 'Ingrese el n° de Empleados Administrativos'
                : 'Ingrese el n° de Auditores Fijos'
            "
          />
        </div>
      </div>

      <div
        class="col-md-6"
        v-if="['OEYC', 'OENY', 'OCLN', 'OICC', 'OINSP'].includes(activity)"
      >
        <div class="form-group">
          <label>{{
            ["OEYC", "OENY", "OCLN", "OICC", "OINSP"].includes(activity)
              ? "Técnicos"
              : "N° de Auditores Externos"
          }}</label>
          <app-input
            type="number"
            v-model="inputs.org.external_auditors"
            :disabled="disabled"
            :placeholder="
              ['OEYC', 'OENY', 'OCLN', 'OICC', 'OINSP'].includes(activity)
                ? 'Ingrese el n° de Técnicos'
                : 'Ingrese el nº de Auditores Externos'
            "
          />
        </div>
      </div>

      <div
        class="col-md-6"
        v-if="
          [
            'OEYC',
            'OENY',
            'OCLN',
            'OINSP',
            'OCSG',
            'CSIA',
            'CSA',
            'CSGAS',
            'OCPR',
          ].includes(activity)
        "
      >
        <div class="form-group">
          <label>N° Total de Ubicaciones Críticas</label>
          <app-input
            type="number"
            v-model="inputs.org.total_critical_locations"
            :disabled="disabled"
            placeholder="Ingrese el nº Total de Ubicaciones Críticas"
          />
          <span class="text-warning"
            >* Se consideran localizaciones críticas aquellas que desempeñen una
            o más funciones descritas en el numeral 3.2</span
          >
        </div>
      </div>

      <div
        class="col-md-6"
        v-if="['OEYC', 'OENY', 'OCLN', 'OINSP'].includes(activity)"
      >
        <div class="form-group">
          <label>Países Donde Opera</label>
          <app-input
            type="textarea"
            v-model="inputs.org.countries_operates"
            :required="true"
            :disabled="disabled"
            placeholder="Ingrese los Paises Donde Opera"
          />
        </div>
      </div>
    </div>

    <div class="row mt-3">
      <legend class="col-12 col-form-label text-primary">
        <h5>Persona Delegada a Efectos de la Acreditación</h5>
      </legend>

      <div class="col-12 col-md-6">
        <div class="form-group">
          <label>Nombre</label>
          <app-input
            type="text"
            v-model="inputs.accApp.delegate_name"
            :required="true"
            :disabled="disabled"
            placeholder="Ingrese el Nombre"
          />
        </div>
      </div>

      <div class="col-12 col-md-6">
        <div class="form-group">
          <label>Cargo</label>
          <app-input
            type="text"
            v-model="inputs.accApp.delegate_position"
            :required="true"
            :disabled="disabled"
            placeholder="Ingrese el Cargo"
          />
        </div>
      </div>

      <div class="col-12 col-md-6">
        <div class="form-group">
          <label>E-mail</label>
          <app-input
            type="email"
            v-model="inputs.accApp.delegate_email"
            :required="true"
            :disabled="disabled"
            placeholder="Ingrese el E-mail"
          />
        </div>
      </div>

      <div class="col-12 col-md-6">
        <div class="form-group">
          <label>Teléfono</label>
          <app-input
            type="tel-input"
            v-model="inputs.accApp.delegate_phone"
            :required="true"
            :disabled="disabled"
            placeholder="Ingrese el Teléfono"
          />
        </div>
      </div>

      <div class="col-12 col-md-6">
        <div class="form-group">
          <label>Celular</label>
          <app-input
            type="tel-input"
            v-model="inputs.accApp.delegate_cell"
            :required="true"
            :disabled="disabled"
            placeholder="Ingrese el Celular"
          />
        </div>
      </div>
    </div>

    <div
      class="row mt-3"
      v-if="['OEYC', 'OENY', 'OCLN', 'OICC'].includes(activity)"
    >
      <legend class="col-12 col-form-label text-primary">
        <h5>
          {{
            ["OEYC", "OENY"].includes(activity)
              ? "El Laboratorio Realiza Ensayos / Calibración para"
              : "El Laboratorio Realiza Análisis para:"
          }}
        </h5>
      </legend>

      <div class="col-md-6">
        <div class="form-group">
          <app-input
            type="checkbox"
            :required="true"
            :list="labOptions"
            v-model="inputs.checkbox"
            :disabled="disabled"
          />
        </div>
      </div>
    </div>

    <div class="mt-5" v-if="!disabled">
      <button
        type="submit"
        class="btn btn-primary mr-2"
        @click.prevent="submit"
      >
        {{ $t("save") }}
      </button>
    </div>
  </form>
</template>

<script>
import { FormMixin } from "@/core/mixins/form/FormMixin.js";
import * as actions from "#/Accreditation/Resources/assets/js/apiUrl";
export default {
  mixins: [FormMixin],
  data() {
    return {
      preloader: false,
      inputs: {
        org: {},
        accApp: {},
        checkbox: [],
      },
      provinceList: [],
      cantonList: [],
      percentage: Array.from(Array(101).keys()).map((i) => {
        return { id: i, value: i };
      }),
      orgs: [],
      selected: null,
      orgTaxid: true,
      lrTaxid: true,
      delayTimer: null,
      taxidTypeLists: [
        { id: "", value: "Seleccione" },
        { id: "ruc", value: "RUC" },
        { id: "other", value: "Otros" },
      ],
      lrTaxidTypeLists: [
        { id: "", value: "Seleccione" },
        { id: "ci", value: "Cédula de Identidad" },
        { id: "other", value: "Otros" },
      ],
    };
  },
  computed: {
    status() {
      return this.$store.state.accreditation.app != null
        ? this.$store.state.accreditation.app.status.code
        : null;
    },
    disabled() {
      return !["100", "112"].includes(this.status);
    },
    activity() {
      return this.$store.state.accreditation.app != null
        ? this.$store.state.accreditation.app.accreditation_activity.code
        : null;
    },
    organizationTypeList() {
      let tmp = [
        { id: "private", value: "Sociedad Privada" },
        { id: "public", value: "Sociedad Pública" },
        { id: "other", value: "Otro" },
      ];
      if (["OICC"].includes(this.activity)) {
        tmp = [
          { id: "IP", value: "Institución Pública" },
          { id: "EP", value: "Empresa Privada" },
          { id: "IE", value: "Institución Educativa" },
          { id: "II", value: "Institución de Investigación" },
          { id: "private", value: "Sociedad Privada" },
          { id: "other", value: "Otro" },
        ];
      }
      return tmp;
    },
    labOptions() {
      if (["OEYC", "OENY"].includes(this.activity)) {
        return [
          {
            id: "PE",
            value: "Propia Entidad",
          },
          {
            id: "OE",
            value: "Otras Entidades",
          },
          {
            id: "PG",
            value: "Público en General",
          },
        ];
      } else if (["OCLN"].includes(this.activity)) {
        return [
          {
            id: "HCCM",
            value: "Hospitales / Clínicas / Centros Médicos",
          },
          {
            id: "OL",
            value: "Otros Laboratorios",
          },
          {
            id: "P",
            value: "Público",
          },
          {
            id: "I",
            value: "Investigación",
          },
        ];
      } else if (["OICC"].includes(this.activity)) {
        return [
          {
            id: "PE",
            value: "Propia Entidad",
          },
          {
            id: "EPGI",
            value: "Entidad del Propio Grupo Industrial",
          },
          {
            id: "OE",
            value: "Otras Entidades",
          },
          {
            id: "PG",
            value: "Público en General",
          },
          {
            id: "I",
            value: "Investigación",
          },
          {
            id: "O",
            value: "Otros",
          },
        ];
      }
    },
    orgList() {
      const tmp = [
        {
          id: null,
          value: "Nueva Organización",
        },
        ...this.orgs.map((item) => {
          return {
            id: item.id,
            value: item.name || item.business_name,
          };
        }),
      ];
      return tmp;
    },
  },
  watch: {
    "inputs.org.country_id": function () {
      this.provinceList = this.$store.getters.getProvinces(
        this.inputs.org.country_id
      );
    },

    "inputs.org.province_id": function () {
      this.cantonList = this.$store.getters.getCantons(
        this.inputs.org.province_id
      );
    },

    "$store.state.common.countries": function () {
      this.provinceList = this.$store.getters.getProvinces(
        this.inputs.org.country_id
      );
      this.cantonList = this.$store.getters.getCantons(
        this.inputs.org.province_id
      );
    },

    "inputs.org.national_capital": function () {
      this.inputs.org.foreign_capital = 100 - this.inputs.org.national_capital;
    },

    selected: function () {
      if (!this.selected) {
        this.inputs.org = {};
      } else if (this.selected != this.inputs.orgs) {
        const tmp = this.orgs.filter((item) => item.id == this.selected);
        this.inputs.org = tmp[0];
      }
    },
  },
  created() {
    this.data();
  },
  methods: {
    beforeSubmit() {
      this.preloader = true;
    },

    submit() {
      if (this.inputs.org.taxid_type == "ruc" && !this.orgTaxid) {
        this.$toastr.e("El RUC no es valido");
        return;
      }
      if (this.inputs.org.lr_taxid_type == "ci" && !this.lrTaxid) {
        this.$toastr.e("La CI no es valida");
        return;
      }

      this.inputs.org.accAppId = this.$store.state.accreditation.id;
      this.inputs.org.establishment_type = "G";
      this.inputs.accApp.fate_laboratory = this.inputs.checkbox.join("|");
      this.save(this.inputs);
    },

    afterSuccess(response) {
      const { orgs, accApp } = response.data;
      if (!accApp.delegate_phone) accApp.delegate_phone = "";
      if (!accApp.delegate_cell) accApp.delegate_cell = "";

      if (accApp.organization) {
        this.inputs.org = accApp.organization;
        this.selected = accApp.organization.id;
      }
      this.inputs.accApp = accApp;
      this.orgs = orgs;

      if (accApp.fate_laboratory) {
        this.inputs.checkbox = accApp.fate_laboratory.split("|");
      }

      this.$store.state.accreditation.org = { ...accApp.organization };

      this.$toastr.s(this.$t("updated_success"));
    },

    afterFinalResponse() {
      this.preloader = false;
    },

    afterError(res) {
      this.$toastr.e(res.data.message);
    },

    data() {
      this.$store.dispatch("getPoliticalDivision");
      // if (this.$store.state.accreditation.org) {
      //   this.inputs.org = { ...this.$store.state.accreditation.org };
      //   return;
      // }

      this.preloader = true;

      this.axiosGet(
        `${actions.ORGANIZATIONS}/index?accAppId=${this.$store.state.accreditation.id}`
      )
        .then((response) => {
          if (response.status == 200 && response.data) {
            const { orgs, accApp } = response.data;
            if (!accApp.delegate_phone) accApp.delegate_phone = "";
            if (!accApp.delegate_cell) accApp.delegate_cell = "";

            if (accApp.organization) {
              this.inputs.org = accApp.organization;
              this.selected = accApp.organization.id;
            }
            this.inputs.accApp = accApp;
            this.orgs = orgs;

            if (accApp.fate_laboratory) {
              this.inputs.checkbox = accApp.fate_laboratory.split("|");
            }

            this.$store.state.accreditation.org = { ...accApp.organization };
          }
        })
        .catch((error) => {
          console.log(error);
        })
        .finally(() => {
          this.preloader = false;
        });
    },
    onChangeTaxid() {
      if (
        this.inputs.org.taxid_type &&
        this.inputs.org.taxid &&
        this.inputs.org.taxid_type == "ruc"
      ) {
        clearTimeout(this.delayTimer);
        this.delayTimer = setTimeout(() => {
          if (this.inputs.org.taxid.length != 13) {
            this.$toastr.e("El campo RUC debe tener 13 digitos");
            return;
          }
          this.validateTaxid("org", "ruc", this.inputs.org.taxid);
        }, 1000);
      }
    },
    onChangeLrTaxid() {
      if (
        this.inputs.org.legal_representative_taxid &&
        this.inputs.org.lr_taxid_type == "ci"
      ) {
        clearTimeout(this.delayTimer);
        this.delayTimer = setTimeout(() => {
          this.validateTaxid(
            "lr",
            "ci",
            this.inputs.org.legal_representative_taxid
          );
        }, 1000);
      }
    },
    validateTaxid(origin, type, taxid) {
      this.preloader = true;
      let url;
      if (origin == "org")
        url = `/register/users/validateRucOrg/${taxid}/${
          this.inputs.org.id == null ? 1 : 0
        }`;
      else url = `/register/users/validate/${taxid}/${type}`;
      this.axiosGet(url)
        .then((response) => {
          if (response.status == 200) {
            if (!response.data.validate) {
              this.$toastr.e(response.data.message);
            }

            if (origin == "org") this.orgTaxid = response.data.validate;
            else this.lrTaxid = response.data.validate;
          }
        })
        .catch(({ error }) => {
          console.log(error);
        })
        .finally(() => {
          this.preloader = false;
        });
    },
  },
};
</script>
